import { Box, Container, Paper } from '@mui/material'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import BillingDetails from './components/BillingDetails'
import CompleteTransfer from './components/CompleteTransfer'
import TransferAcceptInvite from './components/TransferAcceptInvite'
import apiClient from '../../api/apiClient'
import { ReactComponent as AirImpactLogo } from '../../assets/img/logo/airimpact-logo-colorful-with-text.svg'
import Stepper from '../../components/StepperComponent'

interface IWorkspaceTransferDetails {
  name: string
  workspace: {
    id: string
    name: string
  }
  code: string
  transfer: string
}

function StepContent({
  activeStep,
  setActiveStep,
  workspaceDetails,
}: {
  activeStep: number
  setActiveStep: Dispatch<SetStateAction<number>>
  workspaceDetails: IWorkspaceTransferDetails
}) {
  switch (activeStep) {
    case 0:
      return <TransferAcceptInvite setActiveStep={setActiveStep} workspaceDetails={workspaceDetails} />
    case 1:
      return <BillingDetails setActiveStep={setActiveStep} />
    case 2:
      return <CompleteTransfer />
    default:
      return null
  }
}

function TransferOwnershipInviteView() {
  const [activeStep, setActiveStep] = useState<number>(0)
  const [workspaceDetails, setWorkspaceDetails] = useState<IWorkspaceTransferDetails>({
    name: '',
    workspace: {
      id: '',
      name: '',
    },
    code: '',
    transfer: '',
  })
  const location = useLocation()

  const steps = [
    { label: 'Accept invite', description: 'Confirm to transfer ownership' },
    { label: 'Billing details', description: 'Please provide your billing details' },
    { label: 'Complete ownership transfer', description: 'Go to dashboard and start collaborating' },
  ]

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const transferId = queryParams.get('transferId') || ''
    const code = queryParams.get('code') || ''
    let workspaceIdTransfer = ''

    const splittedURL = window.location.pathname.split('/transfer_ownership/')[1]
    if (splittedURL) {
      workspaceIdTransfer = splittedURL.split(/[^0-9a-z]+/)[0]
    }

    const getTransferOwnershipRequest = async () => {
      try {
        const data = await apiClient.get<any, any>(
          `/workspace/${workspaceIdTransfer}/ownership/transfer/${transferId}?inviteCode=${code}`,
        )
        const response = data.data

        setWorkspaceDetails({
          name: response.data.assignor.user.name,
          workspace: {
            id: workspaceIdTransfer,
            name: response.data.workspace.name,
          },
          code,
          transfer: transferId,
        })
      } catch (error) {
        console.error(error)
      }
    }
    getTransferOwnershipRequest()
  }, [location.search])

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column', background: '#f5f8f6' }}>
      <Container
        maxWidth="lg"
        sx={{
          height: '100%',
          minHeight: '100vh',
        }}
      >
        <Box
          sx={{
            padding: '62.5px 0px 33px',
          }}
        >
          <AirImpactLogo />
        </Box>

        <Stepper activeStep={activeStep} steps={steps} />

        <Box sx={{ display: 'flex', justifyContent: 'center', height: '100%', padding: 3 }}>
          <StepContent activeStep={activeStep} setActiveStep={setActiveStep} workspaceDetails={workspaceDetails} />
        </Box>
      </Container>
    </Paper>
  )
}

export default TransferOwnershipInviteView
